gsap.registerPlugin(ScrollTrigger);
//====================== SECTION 2
gsap.to('.co-bags-section-3-left img', {
  scrollTrigger: {
    trigger: ".co-bags-section-3",
    start: "top bottom",
    end: "bottom top",
    scrub: true
  },
  scale: 1.1
});
//====================== SECTION 5
gsap.to('.co-bags-section-5---left img', {
  scrollTrigger: {
    trigger: ".co-bags-section-5---left",
    start: "top bottom",
    end: "bottom top",
    scrub: true
  },
  scale: 1.3
});
gsap.to('.co-bags-section-5---right img', {
  scrollTrigger: {
    trigger: ".co-bags-section-5---right",
    start: "top bottom",
    end: "bottom top",
    scrub: true
  },
  scale: 1.1
});
//====================== SECTION 6
gsap.to('#co-bags-section-6-img-wrapper-id img', {
  scrollTrigger: {
    trigger: ".co-bags-section-6",
    start: "top bottom",
    end: "bottom top",
    scrub: true
  },
  scale: 1.1
});
gsap.to('#co-bags-section-6-outline-wrapper', {
  scrollTrigger: {
    trigger: ".co-bags-section-6",
    start: "top bottom",
    end: "bottom top",
    scrub: true
  },
  top: "60%"
});
gsap.set('#co-bags-section-6-outline-wrapper-h2-2', {autoAlpha: 0});
gsap.to('#co-bags-section-6-outline-wrapper-h2-1', {
  scrollTrigger: {
    trigger: ".co-bags-section-6",
    start: "50% 50%",
    end: "50% 50%",
    toggleActions: "restart none none reverse"
  },
  autoAlpha: 0,
  duration: 0.5
});
gsap.to('#co-bags-section-6-outline-wrapper-h2-2', {
  scrollTrigger: {
    trigger: ".co-bags-section-6",
    start: "50% 50%",
    end: "50% 50%",
    toggleActions: "restart none none reverse"
  },
  autoAlpha: 1,
  duration: 0.5
});
//====================== SECTION 7
gsap.to('.co-bags-section-7---left-cont img', {
  scrollTrigger: {
    trigger: ".co-bags-section-7---left-cont",
    start: "top bottom",
    end: "bottom top",
    scrub: true
  },
  top: "-20%"
});
//====================== SECTION 9
gsap.to('#co-bags-section-9-img-wrapper-id img', {
  scrollTrigger: {
    trigger: ".co-bags-section-9",
    start: "top bottom",
    end: "bottom top",
    scrub: true
  },
  scale: 1.1
});
gsap.to('#co-bags-section-9-outline-wrapper', {
  scrollTrigger: {
    trigger: ".co-bags-section-9",
    start: "top bottom",
    end: "bottom top",
    scrub: true
  },
  top: "60%"
});
gsap.set('#co-bags-section-9-outline-wrapper-h2-2', {autoAlpha: 0});
gsap.to('#co-bags-section-9-outline-wrapper-h2-1', {
  scrollTrigger: {
    trigger: ".co-bags-section-9",
    start: "50% 50%",
    end: "50% 50%",
    toggleActions: "restart none none reverse"
  },
  autoAlpha: 0,
  duration: 0.5
});
gsap.to('#co-bags-section-9-outline-wrapper-h2-2', {
  scrollTrigger: {
    trigger: ".co-bags-section-9",
    start: "50% 50%",
    end: "50% 50%",
    toggleActions: "restart none none reverse"
  },
  autoAlpha: 1,
  duration: 0.5
});
//====================== SECTION 8
gsap.to('.co-bags-section-8---right img', {
  scrollTrigger: {
    trigger: ".co-bags-section-8---right",
    start: "top bottom",
    end: "bottom top",
    scrub: true
  },
  scale: 1.2
});

